import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  bg: {
    translation: {
      // Auth
      login: 'Вход',
      register: 'Регистрация',
      email: 'Имейл',
      password: 'Парола',
      name: 'Име',
      logout: 'Изход',
      // Navigation
      dashboard: 'Табло',
      clients: 'Клиенти',
      employees: 'Служители',
      deals: 'Сделки',
      contracts: 'Договори',
      finances: 'Финанси',
      tasks: 'Задачи',
      marketing: 'Маркетинг',
      equipment: 'Оборудване',
      notifications: 'Известия',
      users: 'Потребители',
      // Common
      add: 'Добави',
      edit: 'Редактирай',
      delete: 'Изтрий',
      save: 'Запази',
      cancel: 'Откажи',
      search: 'Търсене',
      actions: 'Действия',
      status: 'Статус',
      date: 'Дата',
      // Stats
      total_clients: 'Общо клиенти',
      total_employees: 'Общо служители',
      total_contracts: 'Общо договори',
      total_tasks: 'Общо задачи',
      monthly_revenue: 'Месечен приход',
      // Client fields
      company_name: 'Фирма',
      eik: 'ЕИК',
      address: 'Адрес',
      contact_person: 'Лице за контакт',
      phone: 'Телефон',
      monthly_fee: 'Месечна такса',
      package: 'Пакет',
      contract_expiry: 'Изтичане на договор',
      vehicle_count: 'Брой автомобили',
      vehicles: 'Автомобили',
      comments: 'Коментари',
      drive_link: 'Google Drive линк',
      // Vehicle fields
      make: 'Марка',
      model: 'Модел',
      year: 'Година',
      registration: 'Регистрация',
      installation_details: 'Детайли за монтаж',
      // Employee fields
      department: 'Отдел',
      permissions: 'Права',
      role: 'Роля',
      // Contract fields
      contract_number: 'Номер на договор',
      start_date: 'Начална дата',
      end_date: 'Крайна дата',
      services: 'Услуги',
      generate_contract: 'Генерирай договор',
      generate_protocol: 'Генерирай протокол',
      archive: 'Архивирай',
      // Packages
      basic: 'Basic',
      standard: 'Standard',
      premium: 'Premium'
    }
  },
  en: {
    translation: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      logout: 'Logout',
      dashboard: 'Dashboard',
      clients: 'Clients',
      employees: 'Employees',
      deals: 'Deals',
      contracts: 'Contracts',
      finances: 'Finances',
      tasks: 'Tasks',
      marketing: 'Marketing',
      equipment: 'Equipment',
      notifications: 'Notifications',
      users: 'Users',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      search: 'Search',
      actions: 'Actions',
      status: 'Status',
      date: 'Date',
      total_clients: 'Total Clients',
      total_employees: 'Total Employees',
      total_contracts: 'Total Contracts',
      total_tasks: 'Total Tasks',
      monthly_revenue: 'Monthly Revenue',
      company_name: 'Company',
      eik: 'ID Number',
      address: 'Address',
      contact_person: 'Contact Person',
      phone: 'Phone',
      monthly_fee: 'Monthly Fee',
      package: 'Package',
      contract_expiry: 'Contract Expiry',
      vehicle_count: 'Vehicle Count',
      vehicles: 'Vehicles',
      comments: 'Comments',
      drive_link: 'Google Drive Link',
      make: 'Make',
      model: 'Model',
      year: 'Year',
      registration: 'Registration',
      installation_details: 'Installation Details',
      department: 'Department',
      permissions: 'Permissions',
      role: 'Role',
      contract_number: 'Contract Number',
      start_date: 'Start Date',
      end_date: 'End Date',
      services: 'Services',
      generate_contract: 'Generate Contract',
      generate_protocol: 'Generate Protocol',
      archive: 'Archive',
      basic: 'Basic',
      standard: 'Standard',
      premium: 'Premium'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'bg',
    lng: 'bg',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
